/**
 * Remove the subscription option for selected products (matched by title).
 *
 * HOW TO ADD TITLES:
 * Copy the title column from your Excel sheet and paste it between the
 * backticks below, ONE TITLE PER LINE. No quotes or commas needed.
 * Extra spaces, letter case and curly quotes are ignored when matching.
 */
const EXCLUDED_TITLES_TEXT = `
4 Cats & Dogs Gus Travel Bed
Adams Plus Yard Spray (32 oz)
AeroDawg Aerosol Chamber for Dogs with Asthma
AeroKat Aerosol Chamber for Cats with Asthma
AlphaTRAK 3 Test Strips for Dogs, Cats, & Horses (50 Count)
Animal Dermatology Labs Ear Flushing Drying Lotion for Dogs, 8-oz
Aqueon SmartClean Power Filter with EcoRenew Filter Cartridge
Aspen Chloradine Scrub 4% (Gallon)
Aspen Povidine Iodine Scrub 7.5% (Gallon)
Aspen Povidone Iodine Solution 10% (Gallon)
Bags on Board Blue Waste Bags Refill Pack
Baytril (Enrofloxacin) Coated Tablets, 22.7 mg
Bixbi Digestive Support Powdered Mushroom Supplement For Dogs & Cats (60 g)
Bixbi Skin & Coat Powdered Mushroom Supplement For Dogs & Cats (60 g)
Breeder's Edge Clean Cut Iodine For Cats and Dogs
Buddy Biscuits Oven Baked Crunchy Peanut Butter Dog Treats
Buddy Biscuits Soft & Chewy Peanut Butter Dog Treats
Bully Stick Filled Shin Bone 3-4â€
Calcium Gel Oral Supplement 300mL
Catego Flea & Tick Spot Treatment for Cats over 1.5 lbs
Clindamycin Tablets, 25mg
Coprophagia Stool Eating Deterrent Tablets for Dogs (90 ct)
Cosequin ASU Functional Tablets (240 chewable tablets)
Dogswell Grillers Hip & Joint Duck Recipe Grain-Free Treats for Dogs
Dormosedan (Detomidine hydrochloride) Gel for Horses - 3ml Syringe
Droncit for Dogs, 34 mg
Drontal Plus Tablets 22.7 mg (dogs 2-25 lbs)
Drontal Plus Tablets, 136 mg (dogs 45+ lbs)
Durvet Controlled Iodine Spray 1 Gallon
Durvet Kaolin Pectin Anti Diarrheal Liquid (32 oz)
Enrofloxacin (Generic) Flavored Tablets, 68mg
Equiotic Daily Probiotic Equine Supplement For Horse (30 packets)
EQyss Grooming Products Premier Natural Botanical Equine Shampoo
Exodus (pyrantel Pamoate) Multi-Dose Paste for Horses (47.2 g)
Famciclovir 250mg Tablets (Manufacturer may vary)
Fancy Feast Purely Natural Hand-Flaked Tuna Cat Treats, 1.06-oz
Farnam Vetrolin Sore Muscle & Joint Pain Relief Horse Liniment Spray(32 oz)
Fluvac Innovator 4 Equine Vaccine
Fluvac Innovator 5 Equine Vaccine
Fluvac Innovator 6 Equine Vaccine
Fluvac Innovator EHV-4/1 Equine Vaccine
Fluvac Innovator Equine Influenza Vaccine
Four Paws Magic Coat Professional Series 3-in-1 Deluxe Adjustable Comb For Dogs
Four Paws Magic Coat Professional Series All-Purpose Rotating Pin Comb for Dogs
Four Paws Magic Coat Professional Series Flex & Contour Pin and Bristle Brush for Dogs
Four Paws Magic Coat Professional Series Self-Cleaning Slicker Brush For Pets
Four Paws Quick-Fit Muzzle For Dogs
Fruitables Whole Jerky Bites Bacon & Apple Treats For Dogs (5 oz)
Fullbucket Canine ADD BioClay Plus (10 tubes)
FullBucket Equine Probiotic Pellets (30 Servings)
Fullbucket Medical Muscle Recovery, 450gm
Greenies Digestive Probiotic Clinical Strength Supplements for Dogs
Greenies Pill Pockets Cheese Flavor Treats for Dogs, Capsule Size
Health Extension Freeze-Dried Raw Mixer-Topper-Treat Beef Recipe for Dogs
Health Extension Freeze-Dried Raw Mixer-Topper-Treat Chicken Recipe for Dogs
Health Extension Freeze-Dried Raw Mixer-Topper-Treat Salmon Recipe for Dogs
Healthy HairCare Hair Moisturizer Concentrate for Horses
Herm Sprenger Ultra-Plus Prong Training Collar for Dogs
Hill's Prescription Diet w/d Multi-Benefit Digestive / Weight / Glucose / Urinary Management Vegetable & Chicken Stew Canned Dog Food
Hill's Science Diet Adult 6+ Large Breed Chicken Meal, Barley & Brown Rice Dry Dog Food
Hill's Science Diet Adult Canned Dog Food, Chicken & Barley Entrée (13.1 oz x 12 cans)
Hill's Science Diet Adult Canned Dog Food, Savory Stew with Beef & Vegetables (12.8 oz x 12 cans)
Hill's Science Diet Adult Canned Dog Food, Savory Stew with Chicken & Vegetables (12.8 oz x 12 cans)
Hill's Science Diet Adult Chicken Recipe Dry Cat Food
Hill's Science Diet Adult Dry Cat Food, Chicken & Brown Rice Recipe
Hill's Science Diet Adult Dry Dog Food Chicken & Barley Recipe
Hill's Science Diet Adult Hairball Control Chicken Recipe Dry Cat Food
Hill's Science Diet Adult Hairball Control Light Dry Cat Food
Hill's Science Diet Adult Healthy Mobility Small Bites Chicken Meal, Brown Rice & Barley Recipe Dry Dog Food
Hill's Science Diet Adult Large Breed Dry Dog Food, Lamb Meal & Brown Rice Recipe, 33 lb Bag
Hill's Science Diet Adult Light Canned Cat Food, Liver & Chicken Entrée (2.9 oz x 24 cans)
Hill's Science Diet Adult Light Canned Dog Food with Liver (13.1 oz x 12 cans)
Hill's Science Diet Adult Light Dry Cat Food, Chicken Recipe
Hill's Science Diet Adult Light Dry Dog Food, Chicken Meal & Barley, 30 lb Bag
Hill's Science Diet Adult Light Large Breed Dry Dog Food, Chicken Meal & Barley
Hill's Science Diet Adult Light Small Bites Dry Dog Food, Chicken Meal & Barley
Hill's Science Diet Adult Multiple Benefit Chicken Recipe Dry Cat Food
Hill's Science Diet Adult Ocean Fish Entrée Canned Cat Food (2.9 oz x 24 cans)
Hill's Science Diet Adult Oral Care Dry Cat Food, Chicken Recipe (3.5 lb)
Hill's Science Diet Adult Perfect Digestion Chicken, Barley, & Whole Oats Recipe Dry Cat Food (13 lb)
Hill's Science Diet Adult Perfect Digestion Chicken, Brown Rice, & Whole Oats Recipe Dry Dog Food, 22 lb bag
Hill's Science Diet Adult Perfect Digestion Large Breed Chicken, Dry Dog Food, 22 lb. bag
Hill's Science Diet Adult Perfect Digestion Salmon Recipe Dry Dog Food
Hill's Science Diet Adult Perfect Digestion Salmon, Dry Cat Food (13 lb)
Hill's Science Diet Adult Perfect Weight Canned Dog Food, Hearty Vegetable & Chicken Stew (12.5 oz x 12 cans)
Hill's Science Diet Adult Perfect Weight Chicken Recipe Dry Dog Food
Hill's Science Diet Adult Perfect Weight Dry Cat Food, Chicken Recipe (15 lb)
Hill's Science Diet Adult Perfect Weight Small Bites Dry Dog Food, Chicken Recipe
Hill's Science Diet Adult Savory Turkey Entrée Canned Cat Food (5.5 oz x 24 cans)
Hill's Science Diet Adult Sensitive Stomach & Sensitive Skin Chicken & Rice Recipe Dry Cat Food
Hill's Science Diet Adult Sensitive Stomach & Skin Grain Free Chicken & Potato Recipe Dry Dog Food (24 lb)
Hill's Science Diet Adult Sensitive Stomach & Skin Large Breed Chicken & Barley Recipe Dry Dog Food (30 lb)
Hill's Science Diet Adult Sensitive Stomach & Skin Salmon & Vegetable Entrée Canned Dog Food (12.8 oz x 12 cans)
Hill's Science Diet Adult Sensitive Stomach & Skin Salmon & Yellow Pea Recipe Grain Free Dry Cat Food, Salmon & Yellow Pea Recipe (13 lb)
Hill's Science Diet Adult Sensitive Stomach & Skin Small Bites Chicken Recipe Dry Dog Food
Hill's Science Diet Adult Small Bites Dry Dog Food, Chicken & Barley Recipe
Hill's Science Diet Kitten Canned Cat Food, Liver & Chicken Entrée (2.9 oz x 24 cans)
Hill's Science Diet Kitten Dry Cat Food, Chicken & Brown Rice Recipe (3.5 lb)
Hill's Science Diet Kitten Dry Cat Food, Chicken & Brown Rice Recipe (6 lb)
Hill's Science Diet Kitten Dry Cat Food, Chicken Recipe (15.5 lb)
Hill's Science Diet Kitten Dry Cat Food, Chicken Recipe (3.5 lb)
Hill's Science Diet Kitten Dry Cat Food, Chicken Recipe (7 lb)
Hill's Science Diet Kitten Indoor Dry Cat Food, Chicken Recipe (3.5 lb)
Hill's Science Diet Kitten Indoor Dry Cat Food, Chicken Recipe (7 lb)
Hill's Science Diet Puppy Dry Dog Food, Chicken Meal & Barley Recipe (30 lb)
Hill's Science Diet Puppy Savory Stew with Chicken & Vegetables Canned Dog Food (12.8 oz x 12 cans)
Hill's Science Diet Senior 11+ Dry Cat Food, Chicken Recipe (3.5  lb)
Hill's Science Diet Senior 11+ Dry Cat Food, Chicken Recipe (7 lb)
Hill's Science Diet Senior 7+ Canned Cat Food, Savory Chicken Entrée (2.9 oz x 24 cans)
Hill's Science Diet Senior 7+ Canned Cat Food, Savory Turkey Entrée (2.9 oz x 24 cans)
Hill's Science Diet Senior 7+ Canned Dog Food, Beef & Barley Entrée (13.1 oz x 12 cans)
Hill's Science Diet Senior 7+ Canned Dog Food, Chicken & Barley Entrée (13.1 oz x 12 cans)
Hill's Science Diet Senior 7+ Canned Dog Food, Savory Stew with Beef & Vegetables (12.8 oz x 12 cans)
Hill's Science Diet Senior 7+ Canned Dog Food, Turkey & Barley Entrée (13.1 oz x 12 cans)
Hill's Science Diet Senior 7+ Dry Cat Food, Chicken & Brown Rice Recipe (7 lb)
Hill's Science Diet Senior 7+ Dry Cat Food, Chicken Recipe (16 lb)
Hill's Science Diet Senior 7+ Dry Cat Food, Chicken Recipe (4 lb)
Hill's Science Diet Senior 7+ Dry Cat Food, Chicken Recipe (7 lb)
Hill's Science Diet Senior 7+ Dry Dog Food, Chicken Meal, Barley & Brown Rice Recipe, 33 lb Bag
Hill's Science Diet Senior 7+ Hairball Control Chicken Recipe Dry Cat Food
Hill's Science Diet Senior 7+ Indoor Dry Cat Food, Chicken Recipe (15.5 lb)
Hill's Science Diet Senior 7+ Indoor Dry Cat Food, Chicken Recipe (3.5 lb)
Hill's Science Diet Senior 7+ Indoor Dry Cat Food, Chicken Recipe (7 lb)
Hill's Science Diet Senior 7+ No Corn, Wheat or Soy Dry Dog Food, Chicken, 30 lb Bag
Hill's Science Diet Senior 7+ Senior Vitality Dry Dog Food, Chicken & Rice Recipe, 21.5 lb Bag
Hill's Science Diet Senior 7+ Small Bites Dry Dog Food, Chicken Meal, Barley & Brown Rice Recipe
HyCoat Sterile Solution 20mg (2 mL)
HyCoat Sterile Solution 50mg (10 mL)
JW Pet Multi-Color Swing N Perch Ring
Keto Vitamin Gel Oral Supplement 300mL
Kong AirDog Squeaker Dumbbell Dog Toy
KONG Cat Scratcher Refill Two Pack, 2-Pack
Kong Stuff'N Snacks Bacon & Cheese Flavor Crunchy Treats For Dogs - Small (7 oz)
Kopertox Water-Resistant Horse Thrush Treatment (16 oz)
Kopertox Water-Resistant Horse Thrush Treatment (8 oz)
LED Jellyfish Night Light - Rechargeable Ambient Decoration Lamp, Modern Mood Lighting, Nightstand LED for Bedroom Indoor Use Home Decor
Lixit No Drip Top Fill Water Bottle for Rabbits & Guinea Pigs
Lord Jameson Organic Holiday Gingerbread Treats For Dogs (6 oz)
Mann Pro Nurse All Multi-Species Milk Replacer with Probiotics
Manna Pro Farmhouse Favorites Double Bug Mix Poultry Treat (2 lb)
MannaPro AccuBites Radiance Mane & Tail Supplement
Merrick Purrfect Bistro Grain Free Pasture-Raised Lamb & Carrots Recipe Dry Cat Food
Merrick Purrfect Bistro Grain Free Salmon & Sweet Potato Recipe Dry Cat Food
Merrick Purrfect Bistro Grain Free Wild-Caught Ocean Whitefish & Spinach Recipe Dry Cat Food
Midamox Topical Solution for Cats, 2-5 lbs, Teal Box
Midamox Topical Solution for Cats, 9.1-18 lbs, Purple Box
Midamox Topical Solution for Dogs, 55.1-88 lbs, Blue Box
Midamox Topical Solution for Dogs, 9.1-20 lbs, Teal Box
Mineral Oil (Gallon), (Manufacturer may vary)
Miracle Care Kwik-Stop Styptic Powder for Dogs, Cats & Birds
MyEcoPet Compostable Poop/Waste Bags For Dogs & Cats
Northwest Naturals Freeze-Dried Nuggets Beef & Trout Recipe Raw Diets for Dogs
Nutramax Cosequin Optimized with MSM Joint Health Supplement for Horses - Powder with Glucosamine and Chondroitin, 1400 Grams
Nylabon Power Chew X Bone Chew Toy for Puppies, Beef Flavor
Nylabone Healthy Edibles with DHA Sweet Potato & Turkey Flavor Puppy Chew Treats
Oasis All-Weather Bottle for Small Animals (Assorted Colors)
Oasis Basic Hold-Guard for Small Animal Water Bottles (Assorted Colors)
Omega Fields Horseshine Hoof, Skin & Coat Powder Supplement for Horses
OstiMax (Deracoxib) 100mg Chewable Tablets
OstiMax (Deracoxib) 12mg Chewable Tablets
OstiMax (Deracoxib) 25mg Chewable Tablets
OvaMed (Altrenogest) Solution 0.22% 1 Liter
Oxbow Animal Health Enriched Life Apple Stick Dangly Small Animal Toy
Oxbow Animal Health Garden Select Young Guinea Pig Food (4 lb)
Oxbow Enriched Life Run Around Ball Toy For Small Animals
Oxbow Essentials Adult Rabbit Food
Pet Naturals Daily Multi Chews for Dogs
Pet Naturals Hip & Joint PRO Chews for Dogs
Pet Naturals Scoot Bars Chews for Dogs (30 count)
Petmate 2 Door Top Load Pet Kennel (19 inches)
PetPrevea Plus Topical Treatment for Dogs 23-44 lbs
PetPrevea Plus Topical Treatment for Dogs 45-88 lbs
PetPrevea Plus Topical Treatment for Dogs 5-22 lbs
PetPrevea Plus Topical Treatment for Dogs 89-132 lbs
Polyglycan Injectable Solution 10 mL
Purina Pro Plan Prime Plus 7+ Ocean Whitefish & Salmon Entree Classic Canned Cat Food, 3-oz, case of 24
Quest Equine Oral Gel For Horses (14.4g)
Quest Plus Equine Gel For Horses (14g)
Redbarn Pig Snout Dog Treats
RenaKare (Potassium Gluconate) Powder for Dogs & Cats, 4-oz
Reptile Systems Mercury Vapor D3 UV Basking Lamp
Ruffwear Front Range Dog Harness
Selarid Topical Solution for Dogs 5.1–10 lbs (Selamectin)
Sertraline HCI Tablets, 100mg
Simple Solution Disposable Diapers
Simple Solution Disposable Female Dog Diapers (12 pack)
Simple Solution Urine Destroyer Stain & Odor Remover (gallon)
Simple Solution Washable Female Dog Diaper
Simple Solution Washable Male Dog Wrap
Skout's Honor HydroClear Moist Grooming Wipes (100ct)
SmartBones Protein Rings Chicken & Sweet Potato Flavor
SmartBones Protein Rings Duck, Flax Seed, & Pumpkin
SmartBones Protein Rings Salmon & Chickpea
SmartEquine Treats Peppermint Horse Treats
SmartyKat Scratch Scroll Multi-Surface Scratcher with Snap2It Toy For Cats
Solitude IGR Feed Through Fly Preventive for Horses (6 lb)
Starmark Twist & Lock Roller Dog Toy, Large
Strongid Equine Oral Paste For Horses (20ml)
Synovi G3 Soft Chews Joint Supplement for Dogs
Synovi G4 Soft Chews Joint Supplement for Dogs
Tall Tails Dog Antler Chew, Bacon Flavor
Tiki Cat Silver Grain-Free Wet Food For Cats - Variety Pack (2.4 oz x 12 pouches)
Tomlyn Immune Support L-Lysine Powder For Cats, 3.5-oz
Vectra for Cats, 9 lbs and Over
Vedco Urine Off Formula Odor & Stain Remover For Cats & Kittens, 16.9-oz
Vetameg (flunixin meglumine) Injection (50mg/mL)
VetraSeb CeraDerm CK Antiseptic Shampoo for Cats & Dogs
VetriScience Extra Strength Healthy Gut & Digestion Tablets for Dogs (120 Chewable Tablets)
VetriScience GlycoFlex 2 Joint Supplement for Dogs (120 chewable tablets)
VetriScience Perio Plus Dental Chew for Dogs (30 count)
VetriScience Vetri Liver Supplement for Dogs (60 soft chews)
Vet's Best Flea & Tick Dog Shampoo (12 oz)
Vet's Best Flea & Tick Spot Treatment for Medium Dogs 16-40 lbs (4 doses)
Vet's Best Flea & Tick Spray For Cat and Home - Cotton Spice Scent (32 oz)
Vet's Best Flea & Tick Waterless Bath for Dogs (8 oz)
Vet's Best Flea and Tick Shampoo for Cats (12 oz)
Vet's Best Multi-Vitamin Soft Chews for Dogs (30 soft chews)
Viceton 1g Tablets
Vita Flex Pure C Antioxidant & Connective Tissue Support For Horses (2 lb)
Whimzees Brushzees All Natural Daily Dental Dog Treat X-Large Bulk (18 ct)
Whimzees Brushzees Large Dental Treats For Pets Bulk (30 Count)
Whimzees Stix Dental Chews For Small Dogs (150 count)
Wholistic Pet Organics Feline Complete Multivitamin for Cat Original Whitefish
Wholistic Pet Organics Puppy Complete Organic Pumpkin Flavor Multivitamin for Puppies
`;

/**
 * CSS selectors for your subscription app's widget on the product page.
 * Right-click the subscription box on your store > Inspect, and copy its
 * class or id here. A few common ones are included as examples.
 */
const SUBSCRIPTION_WIDGET_SELECTORS = [
  '.sealsubs-target-element',   // Seal Subscriptions box
];

(function () {
  const normalize = (s) =>
    (s || '')
      .normalize('NFKC')
      .replace(/[\u2018\u2019]/g, "'")
      .replace(/[\u201C\u201D]/g, '"')
      .replace(/[\u2013\u2014]/g, '-')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();

  const excluded = new Set(
    EXCLUDED_TITLES_TEXT.split('\n').map(normalize).filter(Boolean)
  );
    // Let other scripts (like the collection popup) check the list
  window.isSubscriptionExcluded = function (title) {
    return excluded.has(normalize(title));
  };
  // Collection pages: hide the autoship price on excluded product cards
  function hideCollectionAutoship() {
    document
      .querySelectorAll('.collection-autoship-price[data-product-title]:not([data-sub-checked])')
      .forEach((el) => {
        el.setAttribute('data-sub-checked', '1');
        if (excluded.has(normalize(el.dataset.productTitle))) {
          el.style.setProperty('display', 'none', 'important');
        }
      });
  }

  // Collection pages: excluded products get the normal flow instead of the popup
  function convertExcludedCards() {
    document
      .querySelectorAll('[data-custom-atc] [data-sub-popup]:not([data-sub-checked])')
      .forEach((popupBtn) => {
        popupBtn.setAttribute('data-sub-checked', '1');

        const wrap = popupBtn.closest('[data-custom-atc]');
        const form = popupBtn.closest('form');
        const dataEl = wrap && wrap.querySelector('[data-sub-data]');
        if (!form || !dataEl) return;

        let data;
        try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
        if (!excluded.has(normalize(data.title))) return;

        const addBtn = form.querySelector('button[name="add"]');
        const idInput = form.querySelector('input[name="id"]');
        const planInput = form.querySelector('[data-sub-plan-input]');
        if (!addBtn || !idInput) return;

        // Remove the subscription field
        if (planInput) planInput.remove();

        // 1 variant: show Add to Cart directly
        if (!data.variants || data.variants.length < 2) {
          popupBtn.remove();
          addBtn.style.removeProperty('display');
          return;
        }

        // 2+ variants: keep "Choose Options", but no popup
        popupBtn.removeAttribute('data-sub-popup');
        popupBtn.removeAttribute('aria-haspopup');

        popupBtn.addEventListener('click', (e) => {
          e.preventDefault();

          // On click: show the dropdown + Add to Cart
          const select = document.createElement('select');
          select.className = 'atc-variant-select';
          select.setAttribute('aria-label', 'Select variant');
          data.variants.forEach((v) => {
            const opt = document.createElement('option');
            opt.value = v.id;
            opt.textContent = v.title;
            select.appendChild(opt);
          });
          select.value = idInput.value;
          select.addEventListener('change', () => {
            idInput.value = select.value;
            wrap.setAttribute('data-selected-id', select.value);
          });

          addBtn.parentNode.insertBefore(select, addBtn);
          addBtn.style.removeProperty('display');
          popupBtn.style.display = 'none';
          select.focus();
        });
      });
  }

  function runCollectionChecks() {
    hideCollectionAutoship();
    convertExcludedCards();
  }

  runCollectionChecks();
  let collectionScheduled = false;
  new MutationObserver(() => {
    if (collectionScheduled) return;
    collectionScheduled = true;
    requestAnimationFrame(() => {
      collectionScheduled = false;
      runCollectionChecks();
    });
  }).observe(document.body, { childList: true, subtree: true });
  
   // ---------- Single product page ----------
  if (!location.pathname.includes('/products/')) return;

    const isCardOrPopup = (el) =>
    el.closest('.atc-pop, [data-custom-atc]');

  // Hide via a CSS rule, so other scripts rewriting style="" can't undo it
  const css = document.createElement('style');
  css.textContent = '[data-hp-sub-hidden]{display:none!important}';
  document.head.appendChild(css);

  // Title: Liquid variable if present, otherwise read it from the Seal widget
  function getMainProductTitle() {
    if (window.SUBSCRIPTION_CHECK_PRODUCT_TITLE) return window.SUBSCRIPTION_CHECK_PRODUCT_TITLE;
    for (const w of document.querySelectorAll('.sealsubs-target-element[data-product]')) {
      if (isCardOrPopup(w)) continue;
      try { return JSON.parse(w.getAttribute('data-product')).title; } catch (e) {}
    }
    return null;
  }

  function clearSellingPlan(root) {
    root.querySelectorAll('input[name="selling_plan"], select[name="selling_plan"]')
      .forEach((el) => {
        if (isCardOrPopup(el)) return;
        el.value = '';
        el.disabled = true;
      });
  }

  function removeSubscription() {
    // 1. Hide the main Seal widget
    document.querySelectorAll(SUBSCRIPTION_WIDGET_SELECTORS.join(',')).forEach((el) => {
      if (!isCardOrPopup(el)) el.setAttribute('data-hp-sub-hidden', '');
    });

    // 2. Switch Seal to "One-time purchase" so its internal state matches
    document.querySelectorAll('input.sls-option[data-type="one_time"]').forEach((r) => {
      if (isCardOrPopup(r) || r.checked) return;
      r.checked = true;
      r.dispatchEvent(new Event('change', { bubbles: true }));
      r.dispatchEvent(new Event('click', { bubbles: true }));
    });

    // 3. Make sure no selling plan is sent
    clearSellingPlan(document);
  }

  let decided = false;
  let pageExcluded = false;

  function check() {
    if (!decided) {
      const t = getMainProductTitle();
      if (!t) return;            // widget not rendered yet, try again later
      decided = true;
      pageExcluded = excluded.has(normalize(t));
    }
    if (pageExcluded) removeSubscription();
  }

  // Safety net: strip selling_plan right before add-to-cart
  ['submit', 'click'].forEach((type) => {
    document.addEventListener(type, (e) => {
      if (!pageExcluded) return;
      const form = e.target.closest && e.target.closest('form');
      if (!form || isCardOrPopup(form)) return;
      if (type === 'click' && !e.target.closest('[name="add"], [type="submit"]')) return;
      clearSellingPlan(form);
    }, true);
  });

  check();
  let scheduled = false;
  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; check(); });
  }).observe(document.body, { childList: true, subtree: true });
})();